/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdBasicData202,
  PutApiV1PersonIdBasicData400,
  PutApiV1PersonIdBasicData401,
  PutApiV1PersonIdBasicData404,
  PutApiV1PersonIdBasicData409,
  PutApiV1PersonIdBasicData500,
  PutApiV1PersonIdBasicDataMutationRequest,
  PutApiV1PersonIdBasicDataMutationResponse,
  PutApiV1PersonIdBasicDataPathParams,
} from "../../types/personRegisterController/PutApiV1PersonIdBasicData.ts";
import { personBasicDataViewModelSchema } from "../personBasicDataViewModelSchema.ts";
import { updateBasicDataRequestSchema } from "../updateBasicDataRequestSchema.ts";

export const putApiV1PersonIdBasicDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdBasicDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1PersonIdBasicData202Schema = z.lazy(
  () => personBasicDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdBasicData202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdBasicData400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdBasicData400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdBasicData401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdBasicData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdBasicData404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdBasicData404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1PersonIdBasicData409Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdBasicData409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdBasicData500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdBasicData500>;

export const putApiV1PersonIdBasicDataMutationRequestSchema = z.lazy(
  () => updateBasicDataRequestSchema,
) as unknown as ToZod<PutApiV1PersonIdBasicDataMutationRequest>;

export const putApiV1PersonIdBasicDataMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdBasicData202Schema,
) as unknown as ToZod<PutApiV1PersonIdBasicDataMutationResponse>;
